import { render, staticRenderFns } from "./offer-layout-chain.vue?vue&type=template&id=04533629&scoped=true"
import script from "./offer-layout-chain.vue?vue&type=script&lang=js"
export * from "./offer-layout-chain.vue?vue&type=script&lang=js"
import style0 from "./offer-layout-chain.vue?vue&type=style&index=0&id=04533629&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04533629",
  null
  
)

export default component.exports